<script>
import vueFilePond, { setOptions } from "vue-filepond";
import "filepond/dist/filepond.min.css";

const FilePond = vueFilePond();

export default {
  props: {
  },
  components: {
    FilePond,
  },
  data() {
    return {
      files: null,
      success: false,

      url: process.env.VUE_APP_URL_API,
      token: localStorage.token,

      response: null,
    };
  },
  methods: {
    getFiles() {
      console.log('');
    },
  },
  created() {
    setOptions({
      server: {
        process: {
          headers: {
            "x-auth-token": localStorage.token,
          },
          onload: (res) => {
            console.log(res)
          }
        },
      },
    });
  },
};
</script>

<template>
  <div>
    <file-pond name="file" ref="file" allowRevert="false" v-bind:files="files" label-idle="Arraste aqui ou escolher arquivo" :server="{
      url:
        url +
        'clientes/importar',
      process: {
        headers: {
          'x-auth-token': this.token,
        },
        onload: (response) => {
          this.response = JSON.parse(response);

          if (this.response.status && this.response.status == 'success') {
            this.$router.push('/clientes/importar/' + this.response.file.id);
          } else if (this.response.status && this.response.status == 'error') {
            this.$toast.error(this.response.message);
          } else {
            this.$parent.$parent.getFiles();
          }
        }
      },
    }" />
  </div>
</template>

<style>
.filepond--root {
  margin-bottom: 0;
}

.filepond--credits {
  display: none !important;
}
</style>
